import icon from "images/icons/icon-action.svg?raw"
import parse from "html-react-parser"

export default function ActionIcon({ title }) {
  return (
    <span className="svg-icon" title={title}>
      {parse(icon)}
    </span>
  )
}
